import { render, staticRenderFns } from "./ShipmentAudits.vue?vue&type=template&id=0399d97f&"
import script from "./ShipmentAudits.vue?vue&type=script&lang=js&"
export * from "./ShipmentAudits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports